<template>
	<input 
		class="form-control" 	
		v-model="date" 
		type="date">
</template>

<script>
	export default {
		props: [
			'classe', 
			'dataDefault', 
			'time'
		],
		data(){
			return {
				date: this.dataDefault,
				isCalculating: false
			}
		},
		created(){
			if(!this.dataDefault){
				this.setDate();
			}
		},
		methods: {
			setDate(){
				var d = new Date();
				// Dia atual
				var day = d.getDate();
				if(day < 10){
					day = "0"+day
				}
				// Mês atual
				var month = d.getMonth() + 1;
				if(month < 10){
					month = "0"+month
				}
				this.date = d.getFullYear()+'-'+month+'-'+day;
	        },
	        expensiveOperation: _.debounce(function () {
	            this.isCalculating = true
	            setTimeout(function () {
	                this.isCalculating = false
	            }.bind(this), this.time)
	        }, 500),
		},
		watch: {
	        date: function () {
	        	if(this.time){
	        		this.expensiveOperation()
	        	} else {
	        		this.$emit('date', this.date);
	        	}
	        },
	        isCalculating: function () {
	            if(this.isCalculating){
	               	this.$emit('date', this.date);
	            }
	        },
	    }
	}
</script>